module.exports = __webpack_public_path__ + "static/media/data_api-01.c3d77581.png";